import React from "react";
import { ArrowLeft, MapPin } from "lucide-react";
import { CATEGORIES } from "../../../data/destinations";

const catLabel = (id) => CATEGORIES.find((c) => c.id === id)?.label ?? id;

export const EscapeHero = ({ parent, onBack }) => (
  <section data-testid="escape-hero" className="relative pt-28 md:pt-32">
    <div className="relative h-[55vh] w-full overflow-hidden">
      <img src={parent.image} alt={parent.title} className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-black/40" />
    </div>
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="-mt-32 relative z-10 max-w-3xl rounded-2xl bg-brand-bg p-8 md:p-12 shadow-xl shadow-black/5">
        <button
          data-testid="back-to-home"
          onClick={onBack}
          className="inline-flex items-center gap-2 text-sm font-medium text-brand-inkSoft hover:text-brand-ink"
        >
          <ArrowLeft size={14} /> Back to all escapes
        </button>
        <p className="overline mt-5 text-brand-inkSoft">{catLabel(parent.category)}</p>
        <h1 data-testid="escape-title" className="font-display mt-3 text-5xl leading-tight md:text-6xl">
          {parent.title}
        </h1>
        <p className="mt-3 inline-flex items-center gap-1.5 text-brand-inkSoft">
          <MapPin size={14} /> {parent.country}
        </p>
        <p className="mt-6 text-base text-brand-inkSoft md:text-lg">{parent.blurb}</p>
      </div>
    </div>
  </section>
);

export default EscapeHero;
